// extracted by mini-css-extract-plugin
export default {"element":"Configurator_element__TvoQR","line":"Configurator_line__2fo4K"};